var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    { staticClass: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse navbar-collapse",
          attrs: { id: "WorkspaceNavigation" },
        },
        [
          _c("ul", { staticClass: "navbar-nav mr-auto" }, [
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "navbar-brand dropdown-toggle text-light",
                  attrs: {
                    id: "navbarDropdown",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.loadUser()
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.workspaceName))])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu",
                  staticStyle: { "max-height": "400px", "overflow-y": "auto" },
                },
                [
                  _vm.user
                    ? _c(
                        "div",
                        _vm._l(_vm.workspacesView, function (g) {
                          return _c(
                            "div",
                            [
                              _c("h6", { staticClass: "dropdown-header" }, [
                                _c("i", {
                                  staticClass: "fa fa-home",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(g.OrganizationUnitName)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm._l(g.Workspaces, function (w) {
                                return _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "sanitizedHref",
                                        rawName: "v-sanitizedHref",
                                        value: `/#/dashboard/${w.Id}`,
                                        expression: "`/#/dashboard/${w.Id}`",
                                      },
                                    ],
                                    key: w.Id,
                                    staticClass: "dropdown-item",
                                  },
                                  [_c("strong", [_vm._v(_vm._s(w.Name))])]
                                )
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                            ],
                            2
                          )
                        }),
                        0
                      )
                    : _c("div", [
                        _vm._v(
                          "\n                        Loading\n                    "
                        ),
                      ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: `/#/scales/${_vm.workspaceId}`,
                      expression: "`/#/scales/${workspaceId}`",
                    },
                  ],
                  staticClass: "nav-link",
                },
                [_vm._v("Scales")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "navbar-nav" }, [
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: {
                    id: "navbarDropdownMenuLink",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                  },
                  on: { click: _vm.loadUser },
                },
                [_c("span", [_vm._v("Account")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu dropdown-menu-right",
                  attrs: { "aria-labelledby": "navbarDropdownMenuLink" },
                },
                [
                  _vm.user
                    ? _c("div", [
                        _vm.user.IsGlobalAdmin || _vm.user.IsOrganizationAdmin
                          ? _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: `/#/admin/organizations/dashboard/${_vm.user.OrganizationUnitId}`,
                                    expression:
                                      "`/#/admin/organizations/dashboard/${user.OrganizationUnitId}`",
                                  },
                                ],
                                staticClass: "dropdown-item",
                              },
                              [
                                _vm._v(
                                  "\n                            Go to admin\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            attrs: { href: "/#/organizations/users/dashboard" },
                          },
                          [_vm._v("My dashboard")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/#/organizations/users/account`,
                                expression: "`/#/organizations/users/account`",
                              },
                            ],
                            staticClass: "dropdown-item",
                          },
                          [_vm._v("Manage your account")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-divider" }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/organizations/sessions/close`,
                                expression: "`/organizations/sessions/close`",
                              },
                            ],
                            staticClass: "dropdown-item",
                          },
                          [_vm._v("Sign out")]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#WorkspaceNavigation",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation",
        },
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }